export var InsistencesGroupingCriteria;
(function (InsistencesGroupingCriteria) {
    InsistencesGroupingCriteria["ByAccountManager"] = "by-account-manager";
    InsistencesGroupingCriteria["ByInsuranceCompany"] = "by-insurance-company";
    InsistencesGroupingCriteria["ByIntent"] = "by-intent";
})(InsistencesGroupingCriteria || (InsistencesGroupingCriteria = {}));
